import { Observable } from "rxjs/Observable";
import { apolloClient } from "../redux/configureStore";
import { gql } from "react-apollo";

export const API_BASE_URL = "http://localhost:4000";

// const ajax = {
//     getJSON: (url) => Observable.of(RxHR.get(url)).map(data => data.body)
// };

const ajax = Observable.ajax;
const variationContents = `
   {
    id
    name
    image
    product {
      id
      name
    }
    price
    fields {
      id
      name
      type
      hint
      ... on SelectField {
        options {
          id
          value
        }
      }
    }
  }
`;

const teamsQuery = `
teams {
  id
  name
}
`;
const productsQuery = `
products {
  id
  name
  image
  variations ${variationContents}
}
`;
const orderLinesQuery = `
  orderLines {
    id
    quantity
    unitPrice
    status
    createdAt
    updatedAt
    statusAt
    variationDetails{
      id
      name
      value
    }
    variation ${variationContents}
  }
`;
const orderContents = `
{
  id
  customerName
  team {
    id
    name
  }
  paid
  delivered
  createdAt
  updatedAt
  ${orderLinesQuery}
}
`;
const ordersQuery = `
orders ${orderContents}
`;
// const getProducts = () => ajax.getJSON(API_BASE_URL + `/products`);
const getInitialData = () => {
  const query = apolloClient.query({
    query: gql` 
      query InitialData {
        ${ordersQuery}
        ${productsQuery}
        ${teamsQuery}
      }
`
  });
  return Observable.from(query).map(res => res.data);
};

const getProducts = () => {
  const query = apolloClient.query({
    query: gql` 
      query Products {
        ${productsQuery}
      }
`
  });

  return Observable.from(query).map(res => res.data.products);
};

const getOrders = () => {
  const query = apolloClient.query({
    fetchPolicy: "network-only",
    query: gql` 
      query Orders {
        ${ordersQuery}
      }
`
  });

  return Observable.from(query).map(res => res.data.orders);
};

const getOrderLines = () => {
  console.log("getOrderLines");
  const query = apolloClient.query({
    fetchPolicy: "network-only",
    query: gql` 
      query OrderLines {
        ${orderLinesQuery}
      }
`
  });

  return Observable.from(query).map(res => res.data.orderLines);
};

const subscribeOrders = () => {
  const orderQuery = gql` 
            query Orders {
              ${ordersQuery}
            }`;
  const query = apolloClient.subscribe({
    query: gql` 
      subscription subscribeOrders{
        orderSaved ${orderContents}
      }
    `,
    variables: {}
  });

  return Observable.from(query).map(res => {
    console.log("SUBSCRIPTION/item:", res);
    const order = res.orderSaved;
    if (order) {
      const data = apolloClient.readQuery({ query: orderQuery });
      const orderFound = data.orders.find(o => o.id === order.id);
      // console.log('store data:',data);
      // console.log('store orderFound:',orderFound);
      if (!orderFound) {
        apolloClient.writeQuery({
          query: orderQuery,
          data: {
            orders: [order, ...data.orders]
          }
        });
      }
    }

    return res.orderSaved;
  });
};

const saveOrderMutation = order => {
  console.log("order", order.toJS());
  const newOrder = {
    id: order.get("id"),
    customerName: order.get("customerName"),
    teamId: order.getIn(["team", "id"]),
    paid: order.get("paid"),
    delivered: order.get("delivered"),
    orderLines: order
      .get("orderLines")
      .map(line => ({
        id: line.get("id"),
        variationId: line.getIn(["variation", "id"]),
        status: line.get("status") || "TODO",
        variationDetails: line
          .get("variationDetails")
          .map(v => ({ name: v.get("name"), value: v.get("value") })),
        quantity: line.get("quantity")
      }))
      .toJS()
  };
  const query = apolloClient.mutate({
    mutation: gql`
      mutation ($order: OrderInput!) {
        saveOrder(order: $order) ${orderContents}
      }
      `,
    variables: { order: newOrder }
    // , optimisticResponse: newOrder
    // , update: (store) => {
    //   store.writeQuery({ query: getOrders });
    // },
  });
  return Observable.from(query).map(res => {
    return res.data.saveOrder;
  });
};

const deleteOrderMutation = orderId => {
  const query = apolloClient.mutate({
    mutation: gql`
      mutation deleteOrder($id: ID!) {
        deleteOrder(orderId: $id)
      }
    `,
    variables: { id: orderId }
    // , optimisticResponse: newOrder
    // , update: (store) => {
    //   store.writeQuery({ query: getOrders });
    // },
  });
  return Observable.from(query).map(res => {
    return res.data.deleteOrder;
  });
};

const setOrderLineStatusMutation = (orderId, orderLineId, status) => {
  console.log("setOrderLineStatusMutation", orderId, orderLineId, status);
  const query = apolloClient.mutate({
    mutation: gql`
      mutation setOrderLineStatusMutation(
        $orderId: ID!
        $orderLineId: ID!
        $status: Status!
      ) {
        setOrderLineStatus(
          orderId: $orderId
          orderLineId: $orderLineId
          status: $status
        ) {
          order {
            id
            customerName
          }
          id
          quantity
          variation {
            id
            name
          }
          status
        }
      }
    `,
    variables: { orderId, orderLineId, status }
    // , optimisticResponse: newOrder
    // , update: (store) => {
    //   store.writeQuery({ query: getOrders });
    // },
  });
  return Observable.from(query).map(res => {
    return res.data.setOrderLineStatus;
  });
};

const getTeams = () => {
  const query = apolloClient.query({
    query: gql`
      query Teams{
        ${teamsQuery}
      }
      `
  });

  return Observable.from(query).map(res => res.data.teams);
};

const getOptionsList = key => ajax.getJSON(API_BASE_URL + `/` + key);

export const apiMethods = {
  getProducts,
  getOrders,
  getOrderLines,
  setOrderLineStatusMutation,
  subscribeOrders,
  getTeams,
  getOptionsList,
  saveOrderMutation,
  deleteOrderMutation,
  getInitialData
};



// WEBPACK FOOTER //
// ./src/api/merchandiseTpvApi.js